import React from 'react';
import PropTypes from 'prop-types';
import { isTeachersEnabled } from 'utils/authScopes';
import ASQHeaderSort from './ASQHeaderSort';

export default class ASQSurveysHeader extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  onSortChange = (e) => {
    const sort = e.currentTarget.dataset.sort;
    const order = this.props.meta.order || 'asc';
    const newOrder = order === 'desc' ? 'asc' : 'desc';
    this.props.onSortChange(sort, newOrder);
  }

  render() {
    const { auth, meta } = this.props;
    return (
      <div className='o-rtable__row'>
        <ASQHeaderSort meta={meta} idx={1} onSortChange={this.onSortChange}>
          <b>Student<br />Name</b>
        </ASQHeaderSort>
        <ASQHeaderSort meta={meta} idx={2} cls='o-rtable__cell--date' onSortChange={this.onSortChange}>
          <b>Date<br />Invited</b>
        </ASQHeaderSort>
        {isTeachersEnabled(auth) && (
          <ASQHeaderSort meta={meta} idx={3} onSortChange={this.onSortChange}>
            <b>Most Recent<br />Teacher ASQ</b>
          </ASQHeaderSort>
        )}
        <ASQHeaderSort meta={meta} idx={4} onSortChange={this.onSortChange}>
          <b>Most Recent<br />Parent ASQ</b>
        </ASQHeaderSort>
        {meta.followUpEnabled &&
          <ASQHeaderSort meta={meta} idx={5} onSortChange={this.onSortChange}>
            <b>Follow-Up</b>
          </ASQHeaderSort>
        }
      </div>
    );
  }
}
